import React, { useRef } from 'react';
import ticketListActions from 'features/ticketList/services/actions';
import { useAppDispatch } from 'store/hooks';
import Button from 'components/Button';
import styled from 'styled-components';
import TrashV2 from 'assets/Icons/trashV2';
import RevokedOrDeleteArchivedModal, { RevokedOrDeleteArchivedModalRef } from '../RevokedOrDeleteArchivedModal';

const DeleteBatchRevokedButton = () => {
  const dispatch = useAppDispatch();
  const revokedOrDeleteArchivedModalRef = useRef<RevokedOrDeleteArchivedModalRef>(null);

  const onUnrevokedTicketSuccess = () => {
    dispatch(ticketListActions.afterDeleteClosedTicket());
  };

  const openDeleteRevorkedModal = () => {
    revokedOrDeleteArchivedModalRef.current?.open();
  };

  return (
    <Container>
      <Button
        ntype='PRIMARY'
        onClick={openDeleteRevorkedModal}
        cardCashier
        iconElement={<TrashV2 fill='#FFF' />}
      >
        Bulk Delete
      </Button>
      <RevokedOrDeleteArchivedModal
        ref={revokedOrDeleteArchivedModalRef}
        revoked={false}
        onSuccess={onUnrevokedTicketSuccess}
      />
    </Container>
  );
};

export default DeleteBatchRevokedButton;

const Container = styled.div`
  .CONTENT_2 {
    font-size: 22px;
    line-height: 1;
  }
`;
